export default __webpack_public_path__ + "7ce894e12078ca8c5134c0c2ad1670f5.otf";